module.exports = __webpack_public_path__ + "img/iconaddmath.afef705f.png";